export const PanelModel = {
    organization: "",
    name: "",
    description: "",
    ilogo: "",
    full_address: "",
    lat:0,
    lng:0,
    token: "",
    duration: "",
    unloading: "",
    project: "",
    sensors: [],
    users: []
}